import { createFileRoute, redirect } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { serviceFeeQueries } from '@/entities/service-fee';
import { ServicesPage } from '@/pages/settings';

export const Route = createFileRoute('/settings/services')({
  staticData: { permission: 'services.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  loader: ({ context }) => {
    void context.queryClient
      .prefetchQuery(serviceFeeQueries.detail())
      .catch(() => undefined);
  },
  component: ServicesPage,
});
